var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import Feature from 'ol/Feature';
import WKT from 'ol/format/WKT';
import { LineString, MultiPoint, Point, } from 'ol/geom';
import { v1 as uuid } from 'uuid';
import { CommonMapService } from './common-map.service';
import { AttrIndexService } from './attr-index.service';
import { CommonTableService } from './common-table.service';
import { GfoService } from './gfo.service';
import { LayerService } from './layer.service';
import { AppinfoService } from './appinfo.service';
import { JstsService } from './jsts.service';
import { SocketService } from './socket.service';
import * as i0 from "@angular/core";
import * as i1 from "./appinfo.service";
import * as i2 from "./attr-index.service";
import * as i3 from "./common-map.service";
import * as i4 from "./common-request.service";
import * as i5 from "./common-table.service";
import * as i6 from "./gfo.service";
import * as i7 from "./jsts.service";
import * as i8 from "./layer.service";
import * as i9 from "./socket.service";
import * as i10 from "./user.service";
;
var FishboneService = /** @class */ (function () {
    function FishboneService(appinfoService, attrIndexService, cMapService, requestService, tableService, gfoService, jstsService, layerService, socketService, userService) {
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.cMapService = cMapService;
        this.requestService = requestService;
        this.tableService = tableService;
        this.gfoService = gfoService;
        this.jstsService = jstsService;
        this.layerService = layerService;
        this.socketService = socketService;
        this.userService = userService;
        this.fishboneControlBS = new BehaviorSubject({
            isOn: true
        });
        // Fishbone messages by processId
        this.fbLogs = new BehaviorSubject({});
        this.onFbFinish = new Subject();
        this.interactiveFishboneSubject = new Subject();
        this.fishboneRoads = {};
    }
    FishboneService.prototype.createFishboneSpikes = function (addrCoord, wktGeocode) {
        if (!addrCoord || !wktGeocode || !wktGeocode.length) {
            return null;
        }
        var wktFormat = new WKT;
        var addrGeocodeGeom = wktFormat.readGeometry(wktGeocode);
        var addrGeocodeCoord = addrGeocodeGeom.getCoordinates();
        var spikeFeats = [];
        if (addrGeocodeGeom.getType() === 'Point') { // addrGeocodeCoord can be Point or MultiPoint // Transform the coords to multipoint for further processing
            addrGeocodeCoord = [addrGeocodeCoord];
        }
        // Create a linestring for each geocode point
        addrGeocodeCoord.map(function (geocodeCoord) {
            var geom = new LineString([addrCoord, geocodeCoord]);
            var feat = new Feature({
                geometry: geom
            });
            spikeFeats.push(feat);
        });
        var geocodeFeat = new Feature({
            geometry: addrGeocodeGeom
        });
        return {
            spikeFeats: spikeFeats,
            geocodeFeat: geocodeFeat
        };
    };
    FishboneService.prototype.analyzeFishbone = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/analyzeFishbone';
            //
            var tempProcessId = uuid();
            _this.socketService.onInitProcess.next({
                tempId: tempProcessId,
                processType: 'AnalyzeFishbone'
            });
            //
            _this.requestService.requestPost(url, {
                userSubscriptionId: _this.userService.getUserInfo().userSubId,
                customerId: _this.userService.customerInfo.id,
                userId: _this.userService.getUserInfo().userId,
                sessionId: _this.appinfoService.getSessionUuid()
            }, function (rsp) {
                console.log(rsp);
                var processesById = _this.fbLogs.getValue();
                var processId = rsp.data.content;
                _this.socketService.onInitProcess.next({
                    tempId: tempProcessId,
                    processId: processId,
                    processType: 'AnalyzeFishbone'
                });
                var process = _this.socketService.registerProcessById(rsp.data.content, processesById);
                _this.fbLogs.next(processesById);
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    // drawFishboneByInfo(olLayer, fbOlLayer, modelKey: ModelMenuItemKey) {
    // 	const features = olLayer.getSource().getFeatures();
    // 	features.forEach(f => {
    // 		const fb: AddressFishboneInfo = f.getProperties()[this.attrIndexService.addrFishboneCol];
    // 		if (!fb) {
    // 			return;
    // 		}
    // 		const fbByModel = modelKey === 'L' ? fb.legacy : fb.nena;
    // 		if (!fbByModel) {
    // 			return;
    // 		}
    // 		// Update address prop
    // 		const fbCode = fbByModel.cd;
    // 		const props = {};
    // 		props[this.attrIndexService.fishboneCodeKey] = fbCode;
    // 		f.setProperties(props);
    // 		//
    // 		const addrCoord = f.getGeometry().getCoordinates();
    // 		const feats = this.createFishboneSpikes(addrCoord, fbByModel.geocode);
    // 		if (feats) {
    // 			fbOlLayer.getSource().addFeatures(feats.spikeFeats);
    // 			fbOlLayer.getSource().addFeatures(feats.geocodeFeat);
    // 		}
    // 	});
    // }
    FishboneService.prototype.getQrFishboneByAttr = function (customerId, qaCodes, gfo, paging, sortColumns) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrFishboneByAttr';
            var params = {
                customerId: customerId,
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (!paging) {
                paging = {
                    pageSize: _this.tableService.defaultTableConfig.pageSize
                };
            }
            else if (!paging.pageSize) {
                paging.pageSize = _this.tableService.defaultTableConfig.pageSize;
            }
            if (sortColumns && sortColumns.length) {
                params.sortColumns = JSON.stringify(sortColumns);
            }
            _this.requestService.setParamsPaging(params, paging);
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    FishboneService.prototype.getQrFishboneByMap = function (customerId, bbox, qaCodes, gfo, sortColumns) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrFishboneByMap';
            var params = {
                customerId: customerId,
                bbox: JSON.stringify(bbox)
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (sortColumns && sortColumns.length) {
                params.sortColumns = JSON.stringify(sortColumns);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                if (rsp && rsp.data) {
                    // Sort so that FSA/FSB will draw before FS1/FS3
                    rsp.data.sort(function (a, b) {
                        if (!b.qa_notes || !b.qa_notes.cd) {
                            return -1;
                        }
                        else if (!a.qa_note || !a.qa_notes.cd) {
                            return 1;
                        }
                        else {
                            if (a.qa_notes.cd < b.qa_notes.cd) {
                                return 1;
                            }
                            else if (a.qa_notes.cd > b.qa_notes.cd) {
                                return -1;
                            }
                            else {
                                return 0;
                            }
                        }
                    });
                }
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    FishboneService.prototype.getQcInterLayerReportByAttrQuery = function (customerId, reportType, qaCodes, gfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttrQuery';
            var params = {
                customerId: customerId,
                reportType: reportType
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data.sql);
            }, function (err) { return reject(err); });
        });
    };
    FishboneService.prototype.buildFishbone = function () {
        // TODO
        // const layer = this.layerService.layerListBS.getValue().layers.find(l => l.category && l.category.code === this.attrIndexService.cateCodeAddress);
        // if (layer && layer.id) {
        // 	this.qcLayers(layer.id, 'fishbone');
        // } else {
        // 	this.toastr.info('Address layer not found');
        // }
    };
    FishboneService.prototype.getFishboneInteractive = function (rcId, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrInterlayerFishboneInteractive';
            var params = {
                customerId: _this.userService.customerInfo.id,
                rclGrdId: rcId
            };
            if (model) {
                params.model = model;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                console.log(rsp);
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    FishboneService.prototype.getFishboneId = function (rec) {
        if (rec[this.attrIndexService.isFishboneAddrKey]) {
            return rec[this.attrIndexService.interlayerGlobalId1];
            // return rec[this.attrIndexService.addrUuidCol];
        }
        else if (rec[this.attrIndexService.isFishboneRoadKey]) {
            return rec[this.attrIndexService.rcUuidCol];
        }
        else {
            console.log('TODO: ??????');
            // TODO:
            // return rec[this.addrUuidCol] + '-' + rec[this.qaNotesColName].cd;
        }
    };
    FishboneService.prototype.getFeaturesFromFishboneData = function (data, isGetRoutes) {
        var _this = this;
        var spikeFeatures = [];
        var addressFeatures = [];
        var routes = {
            layerId: null,
            uuids: []
        };
        data.forEach(function (d) {
            var wkt = d[_this.attrIndexService.addrWktCol];
            var geocodeWkt = d[_this.attrIndexService.interLayerWktCol] ? d[_this.attrIndexService.interLayerWktCol][0] : null;
            var fishboneId = _this.getFishboneId(d);
            var addrUuid = d[_this.attrIndexService.interlayerGlobalId1]; // d[this.attrIndexService.addrUuidCol];
            // const rcUuids = d[this.rcUuidCol2];
            var feats = _this.createAddressAndSpikeFeatures({
                addrWkt: wkt,
                addrGeocodeWkt: geocodeWkt,
                fishboneId: fishboneId,
                addrUuid: addrUuid,
                attrs: d,
            });
            if (feats.spikeFeatures) {
                spikeFeatures = spikeFeatures.concat(feats.spikeFeatures);
            }
            if (feats.addressFeature) {
                addressFeatures.push(feats.addressFeature);
            }
            if (isGetRoutes) {
                // route layer
                var layerId = d[_this.attrIndexService.fishboneRcLayerIdCol];
                var roadIds = d[_this.attrIndexService.rcUuidCol2];
                if (layerId && roadIds) {
                    routes.layerId = layerId;
                    roadIds.forEach(function (i) {
                        if (routes.uuids.indexOf(i) === -1) {
                            routes.uuids.push(i);
                        }
                    });
                }
            }
        });
        return {
            spikeFeatures: spikeFeatures,
            addressFeatures: addressFeatures,
            routes: routes
        };
    };
    FishboneService.prototype.calcFishboneRoads = function (data, overrideFishboneRoads) {
        return __awaiter(this, void 0, void 0, function () {
            var rcUuidCol, fishboneRoads, requestIds_1, filter, gfo, geomRsps, contentRsps_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rcUuidCol = this.attrIndexService.rcUuidCol;
                        fishboneRoads = {};
                        if (!(data.layerId && data.uuids)) return [3 /*break*/, 3];
                        requestIds_1 = [];
                        data.uuids.forEach(function (rcUuid) {
                            if (!_this.fishboneRoads[rcUuid]) {
                                requestIds_1.push(rcUuid);
                            }
                            else {
                                fishboneRoads[rcUuid] = _this.fishboneRoads[rcUuid];
                            }
                        });
                        if (!requestIds_1.length) return [3 /*break*/, 3];
                        filter = this.gfoService.getFilter(rcUuidCol, this.appinfoService.filterOperators.in.name, requestIds_1);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.layerService.getLayerGeometry(data.layerId, null, gfo)];
                    case 1:
                        geomRsps = _a.sent();
                        return [4 /*yield*/, this.layerService.getLayerContents(data.layerId, gfo)];
                    case 2:
                        contentRsps_1 = _a.sent();
                        geomRsps.data.forEach(function (geomRsp) {
                            var uuid = geomRsp[rcUuidCol];
                            var contentRsp = contentRsps_1.data.find(function (i) { return i[rcUuidCol] === uuid; });
                            if (contentRsp) {
                                fishboneRoads[uuid] = {
                                    wkt: geomRsp[_this.attrIndexService.rcGeomCol],
                                    attrs: contentRsp,
                                    uuid: uuid
                                };
                                _this.fishboneRoads[uuid] = fishboneRoads[uuid];
                            }
                        });
                        _a.label = 3;
                    case 3:
                        if (overrideFishboneRoads) {
                            this.fishboneRoads = fishboneRoads;
                        }
                        return [2 /*return*/, fishboneRoads];
                }
            });
        });
    };
    FishboneService.prototype.drawFishboneRoads = function (layer, fishboneRoads) {
        var features = [];
        for (var _i = 0, _a = Object.keys(fishboneRoads); _i < _a.length; _i++) {
            var uuid_1 = _a[_i];
            var route = fishboneRoads[uuid_1];
            var wkt = route.wkt;
            if (!wkt) {
                continue;
            }
            var feat = this.cMapService.createFeatureByWkt(wkt);
            var props = {};
            props[this.attrIndexService.attrKey] = route.attrs;
            props[this.attrIndexService.isFishboneRoadKey] = true;
            // props[this.fishboneCenterlineUuidKey] = route.uuid;
            feat.setProperties(props);
            feat.setId(uuid_1);
            features.push(feat);
        }
        layer.getSource().addFeatures(features);
        return features;
    };
    // Create Address feature AND Spike features (if any)
    FishboneService.prototype.createAddressAndSpikeFeatures = function (d) {
        var _this = this;
        var addressFeature;
        var spikeFeatures;
        if (d.addrGeocodeWkt && d.addrWkt) {
            spikeFeatures = this.createFishspikeFeatures(d.addrWkt, d.addrGeocodeWkt); // It's important the wkt goes before geocodeWkt, the first point will be marked in the style
            // Check long bone
            spikeFeatures.forEach(function (feat) { return _this.checkLongBone(feat); });
        }
        if (d.addrWkt) {
            addressFeature = this.cMapService.createFeatureByWkt(d.addrWkt);
            var props = {};
            props[this.attrIndexService.isFishboneAddrKey] = true;
            props[this.attrIndexService.attrKey] = d.attrs;
            props[this.attrIndexService.fishboneIdKey] = d.fishboneId;
            props[this.attrIndexService.fishboneAddrUuidKey] = d.addrUuid;
            addressFeature.setProperties(props);
            addressFeature.setId(d.addrUuid);
        }
        if (spikeFeatures) {
            // No need to set id for splikes
            // Set properties
            spikeFeatures.forEach(function (feat) {
                var props = {};
                props[_this.attrIndexService.attrKey] = d.attrs;
                props[_this.attrIndexService.fishboneIdKey] = d.fishboneId;
                props[_this.attrIndexService.fishboneAddrUuidKey] = d.addrUuid;
                props[_this.attrIndexService.isFishboneSpikeKey] = true;
                feat.setProperties(props);
            });
        }
        return {
            addressFeature: addressFeature,
            spikeFeatures: spikeFeatures
        };
    };
    // Fishbone spikes can be one or multiple features
    // Create spikes from fishbone's address geom
    FishboneService.prototype.createFishspikeFeatures = function (wkt_addr, wkt_addr_geocode) {
        if (!wkt_addr || !wkt_addr_geocode) {
            return;
        }
        var wktFormat = new WKT;
        var addrGeom = wktFormat.readGeometry(wkt_addr);
        var addrGeocodeGeom = wktFormat.readGeometry(wkt_addr_geocode);
        var addrCoord = addrGeom.getCoordinates();
        var addrGeocodeCoord = addrGeocodeGeom.getCoordinates();
        var features = [];
        if (addrGeocodeGeom.getType() === 'Point') { // addrGeocodeCoord can be Point or MultiPoint // Transform the coords to multipoint for further processing
            addrGeocodeCoord = [addrGeocodeCoord];
        }
        // Create a linestring for each geocode point
        addrGeocodeCoord.map(function (geocodeCoord) {
            var geom = new LineString([addrCoord, geocodeCoord]);
            var feat = new Feature({
                geometry: geom
            });
            features.push(feat);
        });
        return features;
    };
    FishboneService.prototype.checkLongBone = function (feat) {
        var geomType = feat.getGeometry().getType();
        if (geomType === 'LineString') {
            var len = feat.getGeometry().getLength();
            if (len > 300) {
                var props = {};
                props[this.attrIndexService.isLongBoneKey] = true;
                feat.setProperties(props);
                return true;
            }
        }
    };
    FishboneService.prototype.checkCrossBones = function (feats) {
        var _this = this;
        // TODO: If data is too many, got error: Maximum call stack size exceeded error
        if (feats.length > 1000) {
            return;
        }
        var parser = this.jstsService.getJstsParser();
        var setCrossBoneAttr = function (f) {
            var props = {};
            props[_this.attrIndexService.isCrossBoneKey] = true;
            f.setProperties(props);
        };
        var x = 0;
        var check = function (arr) {
            x++;
            if (arr.length <= 1 || x >= 10000) {
                return;
            }
            var geom0 = parser.read(arr[0].getGeometry());
            for (var j = 1; j <= arr.length - 1; j++) {
                var geomJ = parser.read(arr[j].getGeometry());
                var isIntersect = geom0.intersects(geomJ);
                if (isIntersect) {
                    var intersection = _this.jstsService.getJstsOverlayOp().intersection(geom0, geomJ); // geom0.intersection(geomJ);
                    if (intersection.getGeometryType() === 'Point' && intersection.getCoordinates().length === 1) {
                        var intersectPointJsts = intersection.getCoordinates()[0];
                        var coords0 = geom0.getCoordinates();
                        var coordsJ = geomJ.getCoordinates();
                        var onEndOfLine = (intersectPointJsts.equals(coords0[0]) || intersectPointJsts.equals(coords0[coords0.length - 1])) && (intersectPointJsts.equals(coordsJ[0]) || intersectPointJsts.equals(coordsJ[coordsJ.length - 1]));
                        if (onEndOfLine) {
                            continue;
                        }
                    }
                    setCrossBoneAttr(arr[0]);
                    setCrossBoneAttr(arr[j]);
                    arr.splice(j, 1);
                    break;
                }
            }
            arr.splice(0, 1);
            check(arr);
        };
        check(feats.map(function (f) { return f; }));
    };
    FishboneService.prototype.getQrInterlayerFishboneInteractiveBySsap = function (customerId, gadIds, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qrInterlayerFishboneInteractiveBySsap';
            var params = {
                customerId: customerId,
                ssapGadIds: JSON.stringify(gadIds)
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                debugger;
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    FishboneService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FishboneService_Factory() { return new FishboneService(i0.ɵɵinject(i1.AppinfoService), i0.ɵɵinject(i2.AttrIndexService), i0.ɵɵinject(i3.CommonMapService), i0.ɵɵinject(i4.CommonRequestService), i0.ɵɵinject(i5.CommonTableService), i0.ɵɵinject(i6.GfoService), i0.ɵɵinject(i7.JstsService), i0.ɵɵinject(i8.LayerService), i0.ɵɵinject(i9.SocketService), i0.ɵɵinject(i10.UserService)); }, token: FishboneService, providedIn: "root" });
    return FishboneService;
}());
export { FishboneService };
